import {
    ArrayOfCompteDto,
    ArrayOfJournalDto,
    AttributionBudgetModelDto,
    CommissionMailModel,
    CompteDto,
    EditerExecutionAttributionAutoModel,
    JournalDto,
    MutationEditerExecutionAttributionAutoArgs,
    MutationGetAttibutionBdgModelWithIdArgs,
    MutationGetExecutionAutoAttributionModelArgs,
    MutationGetListeCommissionMailArgs,
    MutationGetListeCompteGeneriqueArgs,
    MutationGetListeJournauxGeneriqueArgs,
    MutationGetListeUsersMailArgs,
    MutationSaveAttributionBudgetArgs,
    MutationSupprimerAttributionBudgetArgs,
    UserCommissionDroit,
    UserEmailModel
} from 'src/graphql/generated-types';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import {
    SubventionAllocationGetAction,
} from 'src/app/board/subvention/stores/subvention-allocation/subvention-allocation.action';
import gql from 'graphql-tag';
import { map, switchMap, tap } from 'rxjs/operators';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { Injectable } from '@angular/core';
import { UserState } from 'src/app/_user/store/user/user.state';
import { forkJoin, Observable, of } from 'rxjs';
import {
    VirtualWalletAllocationGetAction,
    VirtualWalletAllocationLoadRelatedListAction,
    VirtualWalletAllocationSaveAction,
    VirtualWalletAllocationSaveAutomatedExecutionAction,
    VirtualWalletContributionArchiveAction
} from 'src/app/board/accounting/stores/accounting-virtual-wallet/accounting-virtual-wallet-allocation';
import {
    AnalyticalPlanInitAnalyticalParametersAction
} from 'src/app/_shared/stores/analytical-plan/analytical-plan.actions';
import { allocationToXML } from 'src/app/board/subvention/stores/subvention-allocation/subvention-allocation.xml';


export class virtualWalletContributionModel {

    allocation: AttributionBudgetModelDto = null;

    automatedAllocationExecution: EditerExecutionAttributionAutoModel = null;

    commissionsList: CommissionMailModel[] = [];

    usersList: UserEmailModel[] = [];

    journalsList: JournalDto[] = [];

    accountsList: CompteDto[] = [];
}

@Injectable()
@State({
    name: 'virtualWalletContribution',
    defaults: new virtualWalletContributionModel()
})
export class AccountingVirtualWalletAllocationState {

    constructor(private readonly graphqlService: GraphqlService,
                private readonly store: Store) {
    }

    private get commissionsRightsList(): UserCommissionDroit[] {
        return this.store.selectSnapshot(UserState.commissionsRightsList);
    }

    @Selector()
    static journalsList(state: virtualWalletContributionModel): JournalDto[] {
        return state.journalsList;
    }

    @Selector()
    static accountsList(state: virtualWalletContributionModel): CompteDto[] {
        return state.accountsList;
    }

    @Selector()
    static allocation(state: virtualWalletContributionModel): AttributionBudgetModelDto {
        return state.allocation;
    }

    @Selector()
    static automatedAllocationExecution(state: virtualWalletContributionModel): EditerExecutionAttributionAutoModel {
        return state.automatedAllocationExecution;
    }


    @Selector()
    static commissionsList(state: virtualWalletContributionModel): CommissionMailModel[] {
        return state.commissionsList;
    }

    @Selector()
    static usersList(state: virtualWalletContributionModel): UserEmailModel[] {
        return state.usersList;
    }


    @Action(VirtualWalletAllocationGetAction)
    getAllocation({patchState}: StateContext<virtualWalletContributionModel>, {allocationId}: VirtualWalletAllocationGetAction) {
        type mutation = 'GetAttibutionBDGModelWithId' | 'GetExecutionAutoAttributionModel';
        type variables = MutationGetAttibutionBdgModelWithIdArgs | MutationGetExecutionAutoAttributionModelArgs;
        if (!allocationId) {
            patchState({allocation: null, automatedAllocationExecution: null});
            return;
        }

        return this.graphqlService.mutateMultiple<mutation, variables>({
            mutation: gql`
                mutation GetAttibutionBDGModelWithId(
                    $contexte: ContextInfosInput,
                    $idAtb: Float
                ) {
                    GetAttibutionBDGModelWithId(
                        contexte: $contexte,
                        idAtb: $idAtb
                    ) {
                        Id
                        Libelle
                        IdCompteChargeAbondement
                        IdComptePMVAbondement
                        IdJournalAbondement
                        IdEnveloppe
                        Code
                        IsNominative
                        DateValeurDefaut
                        IdAnneeRef
                        Description
                        IsCloture
                        IdDelegation
                        IsAttribBoule
                        EnveloppeModel {
                            Id
                            Libelle
                        }
                        ArticleModele {
                            ID
                            Libelle
                        }
                        IdRglAcc
                        MoteurRegleAcc {
                            Id
                            LibelleRegle
                            IsRegleAvancee
                            ModeleRegleAcc {
                                Id
                                IsNominative
                                IsConjointHandicape
                                IsEnfantDirect
                                IsEnfantHandicape
                                IsEnfantACharge
                                AgeEnfantMin
                                AgeEnfantMax
                                IdTypeDateRefAge
                                ModeAccess
                                IdtypeRefAnc
                                # Type de date Saisie
                                DateRefJour
                                DateRefMois
                                # Pour tous les ouvrants droits par ancienneté
                                RgModAccesAnMin
                                RgModAccesAnMax
                                # Variable selon critères
                                IdChamp
                                IdChampAD
                                ListeIdChampAD {
                                    decimal
                                }
                                ListeIdTypeBenef {
                                    decimal
                                }
                                ListeModeleRegleAccListeModele {
                                    RegleAccListeValModelDTO {
                                        IdValeurChamp
                                        AncienneteMinimum # Par ancienneté
                                        AncienneteMaximum # Par ancienneté
                                    }
                                }
                            }
                        }
                        IdRglSubQta
                        MoteurRegleSubQta {
                            Id
                            LibelleRegle
                            IsRegleAvancee
                            TypeRegle
                            ModeleRegleSubQta {
                                Id
                                IdTypeDateRefPond
                                DateRefPondJour
                                DateRefPondMois
                                # Variable selon critères
                                IdChamp
                                ListeModeleRegleSubQuotaValModele {
                                    RegleSubQuotaListeValModelDTO {
                                        Id
                                        ChpLstValId # Critère de type Liste
                                        De # Critère de type numérique
                                        A # Critère de type Numérique
                                        Od
                                        Conjoint
                                        Enfant
                                        Externe
                                        ValMin
                                        ValMax
                                    }
                                }
                                # Paramètres
                                RglModeleIdEnfDir
                                RglModeleIdEnfHan
                                RglModeleIdEnfAch
                                RglModeleSQMontant
                                RglModeleIdAgeEnfMin
                                RglModeleIdAgeEnfMax
                                IsPondererTempsTravail
                                IsPondererMoisPresence
                                IsPondererMoisEntier
                            }
                        }
                        ListeClesRepartition {
                            CleRepartitionModelDTO {
                                IdPlanAnalytique
                                IdSectionAnalytique
                                Pourcentage
                            }
                        }

                        DateDernierMAJ

                        # Exécution
                        AttribTgExec
                        DateExec
                    }

                    GetExecutionAutoAttributionModel(contexte: $contexte, idAttrib: $idAtb) {
                        IdAttrib
                        IdContactParam
                        IsExecutionAuto
                        FrequenceExecution
                        ContactParam {
                            IdCE
                            IdCommission
                            IdUser
                            EmailLibre
                        }
                        NeedSendAlwaysReport
                    }
                }
            `,
            variables: {
                idAtb: allocationId
            }
        }).pipe(
            tap(({GetAttibutionBDGModelWithId, GetExecutionAutoAttributionModel}) => {
                patchState({
                    allocation: GetAttibutionBDGModelWithId,
                    automatedAllocationExecution: GetExecutionAutoAttributionModel
                });
            })
        );
    }

    @Action(VirtualWalletAllocationSaveAction)
    saveAllocation(
        {dispatch}: StateContext<virtualWalletContributionModel>,
        {model}: VirtualWalletAllocationSaveAction
    ) {
        // Une attribution exécutée ne pourra pas être modifiée
        // Les seules modifications possibles concernent l'exécution automatique de l'attribution
        return model.allocation.AttribTgExec && !!model.automatedExecution
            ? this.editAutomatedExecution$(model.automatedExecution)
            : this.editAllocation$(model.allocation).pipe(
                switchMap((allocationId) => {
                    if (!!model.automatedExecution) {
                        return this.editAutomatedExecution$({
                            ...model.automatedExecution,
                            IdAttrib: allocationId
                        });
                    }

                    return of(allocationId);
                }),
                switchMap(allocationId => this.store.dispatch(new VirtualWalletAllocationGetAction(allocationId)).pipe(
                    map(() => allocationId)
                ))
            );
    }

    /**
     * On attend pas de retour de cet appel mais une exception qui est récupérée dans le composant qui fait le dispatch
     */
    @Action(VirtualWalletContributionArchiveAction)
    archiveAllocation({}: StateContext<virtualWalletContributionModel>, {allocationId}: VirtualWalletContributionArchiveAction) {
        return this.graphqlService.mutateOne<'SupprimerAttributionBudget', MutationSupprimerAttributionBudgetArgs>({
            mutation: gql`
                mutation SupprimerAttributionBudget($contexte: ContextInfosInput, $idAtb: Float) {
                    SupprimerAttributionBudget(contexte: $contexte, idAtb: $idAtb)
                }
            `,
            variables: {
                idAtb: allocationId
            }
        });
    }

    @Action(VirtualWalletAllocationSaveAutomatedExecutionAction)
    saveAutomatedExecution({}: StateContext<virtualWalletContributionModel>, {executionModel}: VirtualWalletAllocationSaveAutomatedExecutionAction) {
        return this.editAutomatedExecution$(executionModel).pipe(
            switchMap(id => this.store.dispatch(new SubventionAllocationGetAction(id))),
        );
    }

    @Action(VirtualWalletAllocationLoadRelatedListAction)
    loadRelatedList({patchState}: StateContext<VirtualWalletAllocationLoadRelatedListAction>) {
        return forkJoin({
            journal: this.getJournalsList$(),
            account: this.getAccountsList$(),
            email: this.loadMailsList$(),
            plan: this.store.dispatch(new AnalyticalPlanInitAnalyticalParametersAction()),
        }).pipe(
            tap((forkJoinList) => {
                patchState({
                    journalsList: forkJoinList?.journal?.JournalDTO || [],
                    accountsList: forkJoinList?.account?.CompteDTO || [],
                    commissionsList: forkJoinList?.email?.commissionsList || [],
                    usersList: forkJoinList?.email?.usersList || []
                })
            })
        );
    }

    private loadMailsList$(): Observable<any> {
        type mutations = 'GetListeCommissionMail' | 'GetListeUsersMail';
        type args = MutationGetListeCommissionMailArgs
            | MutationGetListeUsersMailArgs;

        return this.graphqlService.mutateMultiple<mutations, args>({
            mutation: gql`
                mutation loadRelatedListAllocation($contexte: ContextInfosInput, $listeIdCom: ArrayOfdecimalInput) {
                    GetListeCommissionMail(contexte: $contexte, listeIdCom: $listeIdCom) {
                        CommissionMailModel {
                            IdCommission
                            LibelleCommission
                            AdresseMail
                        }
                    }
                    GetListeUsersMail( contexte: $contexte) {
                        UserEmailModel {
                          IdUtilisateur
                          PrenomUtilisateur
                          NomUtilisateur
                          EmailProUtilisateur
                          EmailPersoUtilisateur
                        }
                    }
                }
            `,
            variables: {
                listeIdCom: {
                    decimal: this.commissionsRightsList.map(({IdCommission}) => IdCommission)
                }
            }
        }).pipe(
            map(({
                     GetListeCommissionMail,
                     GetListeUsersMail
                 }) => {
                return {
                    commissionsList: GetListeCommissionMail?.CommissionMailModel || [],
                    usersList: GetListeUsersMail?.UserEmailModel || [],
                }
            })
        );
    }

    private editAllocation$(allocation: AttributionBudgetModelDto): Observable<number> {
        return this.graphqlService.mutateOne<'SaveAttributionBudget', MutationSaveAttributionBudgetArgs>({
            mutation: gql`
                mutation SaveAttribution($contexte: ContextInfosInput, $rawXML: String) {
                    SaveAttributionBudget(contexte:$contexte,  rawXML: $rawXML)
                }
            `,
            variables: {
                rawXML: allocationToXML(allocation)
            }
        });
    }

    private editAutomatedExecution$(executionModel: EditerExecutionAttributionAutoModel): Observable<number> {
        return this.graphqlService.mutateOne<'EditerExecutionAttributionAuto', MutationEditerExecutionAttributionAutoArgs>({
            mutation: gql`
                mutation EditerExecutionAttributionAuto($contexte: ContextInfosInput, $execModel: EditerExecutionAttributionAutoModelInput) {
                    EditerExecutionAttributionAuto(contexte: $contexte, execModel: $execModel) {
                        IdAttrib
                    }
                }
            `,
            variables: {
                execModel: executionModel
            }
        }).pipe(
            map(EditerExecutionAttributionAuto => EditerExecutionAttributionAuto.IdAttrib)
        );
    }

    private getJournalsList$(): Observable<ArrayOfJournalDto> {
        return this.graphqlService.mutateOne<'GetListeJournauxGenerique', MutationGetListeJournauxGeneriqueArgs>({
            mutation: gql`
                mutation GetListeJournauxGenerique(
                  $contexte: ContextInfosInput
                  $critere: CriteresJournalDTOInput
                ) {
                    GetListeJournauxGenerique(
                        contexte: $contexte
                        critere: $critere
                    ){
                         JournalDTO {
                            Id
                            Code
                            Libelle
                            TypeBudget
                            TypeJournal {
                                Code
                            }
                         }
                    }
                }
                `,
            variables: {
                critere: {
                    IsSupprime: false,
                    TakeTypeJournal: true
                }
            }
        });
    }

    private getAccountsList$(): Observable<ArrayOfCompteDto> {
        return this.graphqlService.mutateOne<'GetListeCompteGenerique', MutationGetListeCompteGeneriqueArgs>({
            mutation: gql`
                mutation GetListeCompteGenerique(
                  $contexte: ContextInfosInput
                  $critere: CriteresCompteDTOInput
                ) {
                    GetListeCompteGenerique(
                        contexte: $contexte
                        critere: $critere
                    ){
                        CompteDTO {
                            Id
                            Code
                            Libelle
                            Numero
                            IsCollectifPVMClient
                        }
                    }
                }
                `,
            variables: {
                critere: {
                    IsClotured: false,
                    IsTiers: false,
                    IsSoldeExerciceEnCours: false,
                    TakeBeneficiaire: false,
                    TakeCEDelegation: false,
                    TakeCompteTiers: false,
                    TakeEcriture: false,
                    TakeFournisseur: false,
                    TakeJournal: false,
                    TakeMouvementEtCompte: false,
                    TakePosteBudgetaire: false,
                    TakeSection: false,
                    TakeSectionSSClasseClasse: false
                }
            }
        });
    }
}

